export default __webpack_public_path__ + "static/media/B0_5.8ee070a4.mp3";